import React, { useEffect, useState } from "react";
import { Button, Table } from "antd";
import "./style.css";
import SC from "./style";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader, TableLoader } from "InnoUI/components";
import { formatDateTime } from "utils/config";
import { formatFileSize } from "utils/helper";
import TimezoneConverter from "components/TimeZoneConvertor";
import theme from "@theme/";

const RevisionTable = (props) => {
  const { allDetilsData } = props;
  const [searchParams] = useSearchParams();
  const fileId = searchParams.get("fileId");
  const type = searchParams.get("type");
  const parentId = searchParams.get("parentId");
  const folderId = searchParams.get("folderId");
  const projectId = searchParams.get("projectId");
  const navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (allDetilsData && allDetilsData.length > 0) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [allDetilsData]);

  useEffect(() => {
    if (fileId) {
      const selectedRow = allDetilsData.find(
        (item) => item.id === Number(fileId)
      );
      if (selectedRow) {
        setSelectedRowKeys([selectedRow.id]);
      }
    }
  }, [fileId, allDetilsData]);

  const onRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    navigate(
      `/document/file-details?projectId=${projectId}&fileId=${record.id}&parentId=${parentId}&folderId=${folderId}&type=${type}`
    );
  };

  const revisedData = allDetilsData.map((item, index) => ({
    ...item,
    id: item.id || index,
  }));

  const subColumnData = [
    {
      title: "File Name",
      dataIndex: "subject",
      // sorter: (a, b) => a.subject.localeCompare(b.subject),
      // showSorterTooltip: { target: "sorter-icon" },
      // sortDirections: ["ascend", "descend"],
      onCell: () => ({
        style: { width: "350px", padding: "0px 10px 0px 20px" },
      }),
      render(value, record) {
        return (
          <p
            style={{
              maxWidth: "300px",
              color: theme.colors.black,
              fontSize: "13px",
              opacity: 0.7,
              cursor: "pointer",
              marginBlock: "0px",
              paddingBlock: "0px",
            }}
          >
            {value}
          </p>
        );
      },
    },
    {
      title: "Original File Name",
      dataIndex: "fileName",
      // sorter: (a, b) => a.fileName.localeCompare(b.fileName),
      // showSorterTooltip: { target: "sorter-icon" },
      // sortDirections: ["ascend", "descend"],
      onCell: () => ({
        style: { width: "350px", padding: "0px 0px 0px 12px" },
      }),
      render(value, record) {
        return <SC.ValueSpanP>{value}</SC.ValueSpanP>;
      },
    },
    {
      title: "Size",
      dataIndex: "fileSize",
      onCell: () => ({
        style: { width: "150px", padding: "0px 0px 0px 12px" },
      }),
      render(value, record, index) {
        return <>{formatFileSize(value)}</>;
      },
    },
    {
      title: "Revision",
      dataIndex: "revisionId",
      onCell: () => ({
        style: { width: "50px", padding: "5px", textAlign: "center" },
      }),
      render(value, record, index) {
        return <SC.ValueSpanP>{value}</SC.ValueSpanP>;
      },
    },
    {
      title: "Modified Date & Time",
      dataIndex: "createdOn",
      onCell: () => ({
        style: { width: "250px", padding: "5px" },
      }),
      render(value, record, index) {
        const time = record.lastUpdate || record.createdOn;
        return (
          <SC.ValueSpan>
            <TimezoneConverter time={time} />
          </SC.ValueSpan>
        );
      },
    },
  ];

  return (
    <>
      <div style={{ padding: "10px 15px 10px 15px" }}>
        <Table
          columns={subColumnData}
          dataSource={revisedData}
          rowClassName={(record) =>
            selectedRowKeys.includes(record.id) ? "selected-row" : "hover-row"
          }
          onRow={(record) => ({
            onClick: () => onRowClick(record),
          })}
          pagination={{ pageSize: 15 }}
          loading={{
            indicator: <Loader color="orange" size="medium" />,
            spinning: loading,
          }}
        />
      </div>
    </>
  );
};

export default RevisionTable;
